import { em } from '@mantine/core';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	EDIT_LOGOUT_TIME: 6,
	SIZE_PER_PAGE: 6,
	TEXTAREA_LIMIT: 200,
	NAVBAR_HEIGHT: 88,
	CREATOR_NAVIGATION_HEIGHT: 60,
	INFINITE_SCROLL_PER_PAGE: 3,
	TABLE_PAGE_SIZES: [10, 25, 50],
	MODAL_WIDTH: 528,
	Z_INDEX: {
		NOTIFICATION: 100,
		DRAWER: 104,
		OVERLAY: 50,
		MODAL: 301,
		SCROLL_TOP: 50,
		DRAGGED_PREVIEW: 500,
		TUTORIAL_OVERLAY: 550,
		TUTORIAL_ITEM: 555,
	},
	ROOT_FONT_SIZE: 16,
	BREAKPOINTS: {
		XS: em(576),
		SM: em(768),
		MD: em(992),
		LG: em(1200),
		XL: em(1408),
	},
	DEFAULT_LANGUAGE: 'PL',
	INFINITE_NOTIFICATIONS_PAGE_SIZE: 12,
	COMPLAINT_MAX_LENGTH: 3000,
	COMPLAINT_ATTACHMENTS_MAX: 10,
	COMPLAINT_ATTACHMENTS_MAX_FILE_SIZE_MB: 50,
	THINNING: {
		AVAILABLE_REST_OPTIONS: [40, 42, 43, 46, 48],
		TOTAL_AVAILABLE: 50,
		SIDE_WARNING_TRIGGER: 5,
	},
} as const;

export default APP_CONFIG;
